module.exports = __webpack_public_path__ + "img/bobul_bobocoin.gm.358b681.png";